import React from 'react';

const ThickCheckmark = ({ ...props }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.4375 17.7188C9.5625 17.9062 9.75 17.9688 10 17.9688C10.2188 17.9688 10.4062 17.9062 10.5625 17.7188L19.7812 8.53125C19.9062 8.40625 20 8.21875 20 7.96875C20 7.75 19.9062 7.5625 19.7812 7.40625L18.625 6.28125C18.4688 6.125 18.2812 6.03125 18.0625 6.03125C17.8438 6.03125 17.6562 6.125 17.5 6.28125L10 13.7812L6.5 10.2812C6.3125 10.125 6.125 10.0312 5.90625 10.0312C5.6875 10.0312 5.5 10.125 5.375 10.2812L4.21875 11.4062C4.0625 11.5625 4 11.75 4 11.9688C4 12.2188 4.0625 12.4062 4.21875 12.5312L9.4375 17.7188Z"
      fill="#2277D1"
    />
  </svg>
);

export default ThickCheckmark;
